import React from 'react';
import './ServiceCard.css';
import image1 from '../../images/ser.png';
import image2 from '../../images/ser2.png';
import image3 from '../../images/ser3.png';
import image4 from '../../images/ser4.png';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';

function CustomServiceCard({ title, description, imageUrl }) {
  return (
    
    <div className="custom-service-card">
      <img src={imageUrl} alt={title} className="custom-service-card-image" />
      <h3 className="custom-service-card-title">{title}</h3>
      <p className="custom-service-card-description">
        {Array.isArray(description) ? (
          <ul>
            {description.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        ) : (
          description
        )}
      </p>
    </div>
  );
}

function ServiceCard() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000, // Auto slide every 3 second
    arrows: true,
  };

  return (
    <>
    <div className="custom-container py-5">
      <h2 className="custom-text-center mb-4">Our Services</h2>
      <Slider {...settings}>
        <div>
          <CustomServiceCard
            title="Hassle-free Stay"
            description={[
              "Local guide book",
              "Assistance in local SIM card",
              "Assistance in hotel or guest house selection",
              "Assistance in foreign exchange",
              "Real-time medical updates on the Shinon portal"
            ]}
            imageUrl={image1}
          />
        </div>
        <div>
          <CustomServiceCard
            title="Treatment Related Services:"
            description={[
              "Medical history analysis by specialised doctors",
              "Recommendations for treatments, doctors & hospitals",
              "Second opinion options",
              "Facilitating further procedures at a chosen hospital on priority",
              "Post-treatment support by staying in contact with constant",
              "Follow-ups for patients’ well-being & long-term success rate"
            ]}
            imageUrl={image2}
          />
        </div>
        <div>
          <CustomServiceCard
            title="Holistic Travel Management"
            description={[
              "Visa assistance",
              "Flight booking, airport pickup & drop",
              "Sightseeing recommendation & planning",
              "Language interpreter support",
              "Dedicated case managers"
            ]}
            imageUrl={image3}
          />
        </div>
        <div>
          <CustomServiceCard
            title="Post-Operative Services"
            description={[
              "Post discharge pharmacy & lab solutions",
              "Gathering documentation",
              "Digitizing medical documents",
              "Post-operative follow-ups"
            ]}
            imageUrl={image4}
          />
        <FontAwesomeIcon icon={faArrowLeft}  className="arrow-icons" />
        <FontAwesomeIcon icon={faArrowRight}  className="arrow-icons" />
        </div>
      </Slider> 
    </div>
  </>  
  );
}

export default ServiceCard;
